import { motion } from "framer-motion";
import { PageShell } from "@/components/layout/PageShell";

const sections = [
  { title: "1. What Are Cookies?", content: "Cookies are small text files stored on your device when you visit QA Arena. They help us remember your preferences, analyze usage patterns, and improve your experience." },
  { title: "2. Essential Cookies", content: "Required for the platform to function. These handle authentication, session management, and security. Cannot be disabled." },
  { title: "3. Analytics Cookies", content: "Help us understand how you use QA Arena — which pages you visit, how long you stay, and what features you use most. This data is anonymized and aggregated." },
  { title: "4. Preference Cookies", content: "Remember your settings like theme preference, leaderboard filters, and playground configurations." },
  { title: "5. Managing Cookies", content: "You can manage cookies through your browser settings. Note that disabling essential cookies may affect platform functionality." },
];

export default function CookiesPage() {
  return (
    <PageShell>
      <div className="max-w-3xl mx-auto px-6 lg:px-8 py-24">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
          <span className="text-xs font-mono text-zinc-500 uppercase tracking-[0.2em]">Legal</span>
          <h1 className="font-heading font-bold text-4xl sm:text-5xl text-white mt-3 tracking-tight">Cookie Policy</h1>
          <p className="mt-4 text-sm font-mono text-zinc-500">Last updated: March 1, 2026</p>
        </motion.div>

        <div className="mt-12 space-y-8">
          {sections.map((s, i) => (
            <motion.div key={s.title} initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.05 }}
              data-testid={`cookies-section-${i}`}
            >
              <h2 className="font-heading font-semibold text-white text-lg mb-3">{s.title}</h2>
              <p className="text-sm font-mono text-zinc-400 leading-relaxed">{s.content}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </PageShell>
  );
}
